// extracted by mini-css-extract-plugin
module.exports = {"app-footer":"bs_d4","appFooter":"bs_d4","logo":"bs_dZ","sub-footer":"bs_d5","subFooter":"bs_d5","links":"bs_d6","copy":"bs_d7"};